import React from 'react';

type Props = {
  size?: number;
  color?: string;
  className?: string;
  title?: string;
};

export const StarIcon: React.FC<Props> = ({
  size = 10,
  color = '#000000',
  className,
  title,
}) => (
  <svg
    aria-hidden={title ? undefined : true}
    className={className}
    height={size}
    role={title ? 'img' : 'presentation'}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
  >
    {title ? <title>{title}</title> : null}
    <path
      d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
      fill={color}
      stroke="#FFFFFF"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    />
  </svg>
);
